<template>
  <v-card class="mb-7">
    <v-card-text>
      <v-form>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="senha1"
              :type="isNewPasswordVisible ? 'text' : 'password'"
              :append-icon="isNewPasswordVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
              label="Nova senha"
              :rules="[validators.passwordValidator]"
              outlined
              dense
              hint="Mínimo 8 caracteres."
              persistent-hint
              @click:append="isNewPasswordVisible = !isNewPasswordVisible"
            />

            <v-text-field
              v-model="senha2"
              :type="isCPasswordVisible ? 'text' : 'password'"
              :append-icon="isCPasswordVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
              label="Confirme a nova senha"
              :rules="[validators.required, validators.passwordValidator, validators.confirmedValidator(senha1, senha2)]"
              outlined
              dense
              class="mt-3"
              @click:append="isCPasswordVisible = !isCPasswordVisible"
            />
          </v-col>

          <v-col cols="12">
            <v-btn
              v-if="!acessoPut"
              class="me-3"
              color="primary"
              disabled
            >
              Mudar senha
            </v-btn>

            <v-btn
              v-else
              class="me-3"
              color="primary"
              @click="update"
            >
              Mudar senha
            </v-btn>

            <v-btn
              outlined
              color="secondary"
              type="reset"
              @click.prevent="resetForm"
            >
              Cancelar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>

  <!-- two step verification -->
  <!-- <v-card class="mb-7">
      <v-card-title>
        Two-step verification
      </v-card-title>
      <v-card-subtitle>
        Keep your account secure with authentication step.
      </v-card-subtitle>

      <v-card-text>
        <div>
          <h4 class="font-weight-medium mb-1">
            SMS
          </h4>
          <div class="d-flex align-center justify-space-between">
            <span class="user-verification-number">{{ smsVerificationNumber }}</span>
            <div>
              <v-btn
                icon
                small
                color="secondary"
                @click="istwoFactorDialogOpen = !istwoFactorDialogOpen"
              >
                <v-icon size="20">
                  {{ icons.mdiSquareEditOutline }}
                </v-icon>
              </v-btn>
              <v-btn
                icon
                small
              >
                <v-icon size="20">
                  {{ icons.mdiDeleteOutline }}
                </v-icon>
              </v-btn>
            </div>
          </div>
        </div>

        <v-divider></v-divider>

        <p class="mb-0 mt-4">
          Two-factor authentication adds an additional layer of security to your account by requiring more than just a password to log in. <a
            href="javascript:void(0)"
            class="text-decoration-none"
          >Learn more</a>.
        </p>
      </v-card-text>
    </v-card> -->

  <!-- recent divices -->
  <!-- <v-card>
      <v-card-title>
        Recent devices
      </v-card-title>

      <v-data-table
        :headers="tableColumnHeaders"
        :items="recenntDevices"
        hide-default-footer
        class="text-no-wrap"
      >
        <template #[`item.browser`]="{item}">
          <div class="d-flex align-center">
            <v-avatar
              size="22"
              class="me-2"
            >
              <v-img :src="require(`@/assets/images/logos/${item.browser}`)"></v-img>
            </v-avatar>
            <span class="text--primary text-no-wrap font-weight-medium">{{ item.name }}</span>
          </div>
        </template>
      </v-data-table>
    </v-card> -->
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiSquareEditOutline, mdiDeleteOutline, mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { alphaValidator, emailValidator, passwordValidator, required, confirmedValidator } from '@core/utils/validation'
import ColaboradorService from '@/services/modules/ColaboradorService'

export default {
  props: {
    securityData: {
      type: Object,
      default: () => {},
    },
    acessoPut: {
      type: Boolean,
      default: () => true,
    },
  },

  data() {
    return {
      senha1: '',
      senha2: '',
    }
  },

  setup(props) {
    const accountDataLocale = ref(JSON.parse(JSON.stringify(props.securityData)))

    const resetForm = () => {
      accountDataLocale.value = JSON.parse(JSON.stringify(props.securityData))
    }

    const isCurrentPasswordVisible = ref(false)
    const isNewPasswordVisible = ref(false)
    const isCPasswordVisible = ref(false)

    return {
      resetForm,
      accountDataLocale,
      isCurrentPasswordVisible,
      isNewPasswordVisible,
      isCPasswordVisible,
      icons: {
        mdiSquareEditOutline,
        mdiDeleteOutline,
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
      validators: {
        confirmedValidator,
        required,
        emailValidator,
        passwordValidator,
        alphaValidator,
      },
    }
  },

  methods: {
    update() {
      this.accountDataLocale.senha = this.senha2

      const colaboradorId = this.accountDataLocale.id

      ColaboradorService.update(colaboradorId, this.accountDataLocale)
    },
  },
}
</script>
